import { ImageFromServer } from '@/components/images/ImageFromServer';
import { BoneTag } from '@/generated';
import { Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { safeSchema } from '@/utils/rehype';
import rehypeSanitize from 'rehype-sanitize';
// import { useThesaurusTranslation } from '@/hooks/use-thesaurus-translation.hook';
import { ClickableTag } from './BoneTagEditor';
import { useContext } from 'react';
import { AppContext } from '@/contexts/app.context';

export type BoneInfoCardProps = {
  boneTag?: BoneTag;
  onClick?: () => void;
};

export const BoneInfoCard = (props: BoneInfoCardProps) => {
  const { boneTag } = props;
  const { state } = useContext(AppContext);
  // const { translate } = useThesaurusTranslation();

  return (
    <Card onClick={props.onClick} sx={{ minHeight: 150, height: '100%' }}>
      <CardContent sx={{ height: '100%' }}>
        <Grid sx={{ height: '100%', rowGap: 2 }} container>
          <Grid sx={{ alignItems: 'center', justifyItems: 'flex-start', alignContent: 'center', justifyContent: 'center', m: 1 }} size={3}>
            <Stack>
              <Typography sx={{ overflowWrap: 'break-word', mb: 3 }} variant="h6">
                {boneTag?.name}
              </Typography>
              {props.boneTag?.imageId ? <ImageFromServer sx={{ maxWidth: '90%', maxHeight: 250 }} thumbnail={true} alt="" id={props.boneTag.imageId} /> : <></>}
            </Stack>
          </Grid>

          <Grid size={8}>
            <Stack sx={{ alignContent: 'center', flexDirection: 'row' }}></Stack>
            <Grid container>
              <Grid size={12}>
                <ReactMarkdown rehypePlugins={[rehypeRaw, [rehypeSanitize, safeSchema]]} remarkPlugins={[remarkGfm]}>
                  {boneTag?.description && boneTag?.description !== '' ? boneTag.description : 'No bone selected'}
                </ReactMarkdown>
              </Grid>
              {boneTag?.groupsBoneTagIds && boneTag.groupsBoneTagIds.length ? (
                <Grid size={12}>
                  {boneTag.groupsBoneTagIds.map((gzid) => {
                    const boneTag = state?.boneTagMap.get(gzid);
                    return boneTag ? <ClickableTag tag={boneTag} tagClicked={(t) => {}} /> : <></>;
                  })}
                </Grid>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
